import api from './api';

export const getMyPosts = async () => {

    let resposta = await api.get(`GetMyPosts`).then((response)=>{
        let posts = response.data;
            return posts;
    }).catch((error)=>{

            return error;

    });

    return resposta;

};
